<template>
  <button id="okta-login-btn" class="okta-button" @click="oktaLogin">
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="vertical-align: middle; margin-right: 5px; margin-bottom: 3px"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.90143 0.114105L9.52941 4.67829C9.35771 4.64976 9.18601 4.64976 8.98569 4.64976C8.75676 4.64976 8.52782 4.67829 8.3275 4.70681L8.12719 2.5103C8.12719 2.45325 8.18442 2.36767 8.24165 2.36767H8.61367L8.44197 0.142631C8.44197 0.0855784 8.4992 0 8.55644 0H9.78696C9.87281 0 9.93005 0.0570523 9.90143 0.114105ZM6.81081 0.342314C6.78219 0.285261 6.72496 0.228209 6.66773 0.256735L5.52305 0.684628C5.4372 0.713154 5.40859 0.798732 5.4372 0.855784L6.38156 2.88114L6.03816 3.02377C5.98092 3.0523 5.9523 3.10935 5.98092 3.19493L6.92528 5.19176C7.26868 4.99208 7.6407 4.84945 8.04134 4.76387L6.81081 0.342314ZM4.00636 1.62599L6.66773 5.36292C6.32432 5.59113 6.03816 5.84786 5.7806 6.13312L4.14944 4.56418C4.09221 4.50713 4.09221 4.42155 4.14944 4.39303L4.43561 4.16482L2.86169 2.56735C2.80445 2.5103 2.80445 2.42472 2.86169 2.3962L3.80604 1.62599C3.86328 1.54041 3.94913 1.56894 4.00636 1.62599ZM1.77424 3.76545C1.71701 3.73693 1.63116 3.73693 1.60254 3.79398L1.00159 4.84945C0.972973 4.9065 1.00159 4.99208 1.05882 5.0206L3.09062 5.99049L2.8903 6.30428C2.86169 6.36133 2.8903 6.44691 2.94754 6.47544L4.97933 7.38827C5.12242 7.01743 5.32273 6.67512 5.55167 6.36133L1.77424 3.76545ZM0.257552 6.64659C0.257552 6.58954 0.343402 6.53249 0.400636 6.56101L4.83625 7.70206C4.72178 8.0729 4.66455 8.47227 4.63593 8.87163L2.40382 8.70047C2.34658 8.70047 2.28935 8.64342 2.28935 8.55784L2.34658 8.18701L0.171701 7.98732C0.114467 7.98732 0.0572337 7.93027 0.0572337 7.84469L0.257552 6.64659ZM0.114467 9.64184C0.0286168 9.64184 0 9.69889 0 9.78447L0.228935 10.9826C0.228935 11.0396 0.314785 11.0967 0.372019 11.0681L2.5469 10.4976L2.60413 10.8685C2.60413 10.9255 2.68998 10.9826 2.74722 10.954L4.89348 10.355C4.77901 9.98415 4.69316 9.58479 4.66455 9.18542L0.114467 9.64184ZM0.829889 12.8082C0.801272 12.7512 0.829889 12.6656 0.887122 12.6371L5.03657 10.6688C5.17965 11.0396 5.40858 11.3819 5.66614 11.6957L3.86328 12.9794C3.80604 13.0079 3.72019 13.0079 3.69157 12.9509L3.43402 12.6371L1.57393 13.9208C1.51669 13.9493 1.43084 13.9493 1.40223 13.8922L0.829889 12.8082ZM5.83784 11.9525L2.60413 15.2044C2.5469 15.2615 2.5469 15.3471 2.60413 15.3756L3.54849 16.1458C3.60572 16.2029 3.69157 16.1743 3.72019 16.1173L5.03657 14.2916L5.32273 14.5483C5.37997 14.6054 5.46582 14.5769 5.49444 14.5198L6.75358 12.6941C6.41017 12.4945 6.09539 12.2377 5.83784 11.9525ZM5.20827 17.1442C5.15103 17.1157 5.12242 17.0586 5.15103 16.9731L7.03975 12.8368C7.38315 13.0079 7.78378 13.1506 8.1558 13.2361L7.58347 15.3756C7.55485 15.4326 7.49762 15.4897 7.44038 15.4612L7.09698 15.3185L6.49603 17.4865C6.46741 17.5436 6.41017 17.6006 6.35294 17.5721L5.20827 17.1442ZM8.47059 13.2932L8.09857 17.8574C8.09857 17.9144 8.1558 18 8.21304 18H9.44356C9.50079 18 9.55803 17.9429 9.55803 17.8574L9.38633 15.6323H9.75835C9.81558 15.6323 9.87281 15.5753 9.87281 15.4897L9.6725 13.2932C9.44356 13.3217 9.24324 13.3502 9.01431 13.3502C8.84261 13.3217 8.64229 13.3217 8.47059 13.2932ZM12.9062 0.969889C12.9348 0.912837 12.9062 0.827258 12.849 0.798732L11.7043 0.37084C11.6471 0.342314 11.5612 0.399366 11.5612 0.456418L10.9603 2.62441L10.6169 2.48177C10.5596 2.45325 10.4738 2.5103 10.4738 2.56735L9.90143 4.70681C10.3021 4.79239 10.6741 4.93502 11.0175 5.10618L12.9062 0.969889ZM15.4245 2.76704L12.1908 6.01902C11.9332 5.73376 11.6184 5.47702 11.275 5.27734L12.5342 3.45166C12.5628 3.39461 12.6486 3.39461 12.7059 3.42314L12.9921 3.67987L14.3084 1.8542C14.337 1.79715 14.4229 1.79715 14.4801 1.82567L15.4245 2.59588C15.4531 2.65293 15.4531 2.73851 15.4245 2.76704ZM17.1415 5.33439C17.1987 5.30586 17.2273 5.22029 17.1987 5.16323L16.5978 4.10777C16.5692 4.05071 16.4833 4.02219 16.4261 4.07924L14.566 5.36292L14.3657 5.04913C14.337 4.99208 14.2512 4.96355 14.194 5.0206L12.3911 6.27575C12.6486 6.58954 12.849 6.93185 13.0207 7.30269L17.1415 5.33439ZM17.7997 6.98891L18 8.18701C18 8.24406 17.9714 8.32964 17.8855 8.32964L13.3355 8.75753C13.3068 8.35816 13.221 7.9588 13.1065 7.58796L15.2528 6.98891C15.31 6.96038 15.3959 7.01743 15.3959 7.07448L15.4531 7.44532L17.628 6.8748C17.7138 6.8748 17.7711 6.93185 17.7997 6.98891ZM17.5994 11.4105C17.6566 11.439 17.7424 11.3819 17.7424 11.3249L17.9428 10.1268C17.9428 10.0697 17.9141 9.98415 17.8283 9.98415L15.5962 9.78447L15.6534 9.41363C15.6534 9.35658 15.6248 9.271 15.5389 9.271L13.3068 9.09984C13.3068 9.49921 13.221 9.89857 13.1065 10.2694L17.5994 11.4105ZM16.4261 14.149C16.3975 14.206 16.3116 14.2345 16.2544 14.1775L12.4769 11.5816C12.7059 11.2678 12.9062 10.9255 13.0493 10.5547L15.0811 11.4675C15.1383 11.496 15.1669 11.5816 15.1383 11.6387L14.938 11.981L16.9698 12.9509C17.027 12.9794 17.0556 13.065 17.027 13.122L16.4261 14.149ZM11.3609 12.6086L14.0223 16.3455C14.0509 16.4025 14.1367 16.4025 14.194 16.374L15.1383 15.6038C15.1955 15.5468 15.1955 15.4897 15.1383 15.4326L13.5644 13.8352L13.8506 13.607C13.9078 13.5499 13.9078 13.4929 13.8506 13.4358L12.2766 11.8669C12.0191 12.1521 11.7043 12.4089 11.3609 12.6086ZM11.3609 17.6862C11.3037 17.7147 11.2178 17.6577 11.2178 17.6006L10.0159 13.2076C10.4165 13.122 10.7886 12.9794 11.132 12.7797L12.0763 14.7765C12.1049 14.8336 12.0763 14.9192 12.0191 14.9477L11.6757 15.0903L12.62 17.1157C12.6486 17.1727 12.62 17.2583 12.5628 17.2868L11.3609 17.6862Z"
        fill="white"
      />
    </svg>
    {{ t('okta.loginWithOkta') }}
  </button>
</template>

<script>
import customersApi from '@/api/customersApi.js'
import { mapState, mapMutations } from 'vuex'
import { OktaAuth } from '@okta/okta-auth-js'
import i18n from '@/plugins/i18n'

export default {
  emits: ['getCustomerInfo', 'showLoader', 'ssoError'],
  computed: {
    ...mapState(['loyaltyBaseUrl', 'loyaltyClientId']),
  },
  data() {
    return {
      oktaAuth: '',
      oidc: {
        clientId: null,
        issuer: null,
        redirectUri: window.location.origin + '/login/callback',
        scopes: ['openid', 'profile', 'email'],
      },
    }
  },
  created() {
    this.oidc.clientId = this.loyaltyClientId
    this.oidc.issuer = this.loyaltyBaseUrl
    this.oktaAuth = new OktaAuth(this.oidc)
  },
  name: 'OktaSSO',
  methods: {
    ...mapMutations(['SET_COOKIES']),
    t(key, params = {}) {
      return i18n.global.t(key, params)
    },
    async oktaLogin() {
      try {
        const response = await this.oktaAuth.token.getWithPopup({ responseType: 'id_token' })
        this.handleCredentialResponse(response.tokens.accessToken.accessToken)
      } catch (error) {
        console.error(error)
      }
    },

    handleCredentialResponse(token) {
      this.$emit('showLoader')
      let payload = {
        provider: 'okta',
        auth_info: {
          access_token: token,
        },
      }
      customersApi
        .foreignAuth(payload)
        .then((response) => {
          localStorage.setItem('customerId', response.data.data.customer_id)
          this.SET_COOKIES(response.data.cookies)
          this.$emit('getCustomerInfo')
        })
        .catch((error) => {
          console.log(error)
          this.$emit('ssoError')
        })
    },
  },
}
</script>

<style scoped>
.okta-button {
  background-color: #3f59e4;
  text-transform: uppercase;
}
svg {
  vertical-align: middle;
}
</style>